import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.css']
})
export class UnderConstructionComponent implements OnInit {

  constructor(private routers: Router) { }

  ngOnInit() {
  }

  onRedirectTo(){
    this.routers.navigate(['/home']);
  }

}
